/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import "../../App.css";
import LangContext from "../../contextProvider/LangContext";
import GenericTable from "../../components/GenericTable";
import GenericSelector from "../../components/GenericSelector";
import { Button, Checkbox, Col, Form, Icon, InputNumber, message, Modal, Radio, Select, Tooltip } from "antd";
import TableIDs from "../../data/TableIDs";
import moment from "moment";
import TableLineIcons from "../../components/TableLineIcons";
import GenericModal from "../../components/GenericModal";
import { Row } from "antd/es/grid";
import SelectorItemClassic from "../../components/SelectorItemClassic";
import GenericSelectorItemTags from "../../components/GenericSelectorItemTags";
import DateTimePicker from "../../components/DateTimePicker";
import { Job, User, OutputType, ProcessType } from '../../JmReact';
import ResponsiveTable from "../../components/ResponsiveTable";
import GenericSelectorBranches from "../../components/GenericSelectorBranches";
import ReportExcelBtn from "../../components/ReportExcelBtn";


class ExcludedItems extends Component {
    constructor(props: Props) {
        super(props);
        this.state = {
            importTagId: null,
            modalFilter: false,
            _branchList: "",
            _itemTagList: "",
            _typeView: "0",
            editWeekDaysNotExc: "-1",

            modalWeekView: false,
            modalWeekBranch: null,
            modalWeekCategory: null,
            modalWeekViewExcelPrint: null,
        };

        this.id = "EXCLUDED_ITEMS";
        this.week_id = "INCLUDE_ITEMS_WEEK";
        this.week_id_all = "INCLUDE_ITEMS_WEEK_ALL";
        this.setting_id = "FORMAT_SITE_SETTINGS";


        this.api = {
            get: "get_excluded_items",
            create_edit: "create_edit_excluded_items",
            delete: "delete_excluded_items",

            get_week: "include_items_week",
            get_settings: "get_orders_site_settings",

        }

        this.selectors = [
            { id: TableIDs.genericSelectorBranches, api: "get_branch_list" },
            { id: TableIDs.genericSelectorStorages, api: "get_storage_list" },
            { id: TableIDs.genericSelectorPos, api: "list_pos" },
            { id: TableIDs.genericSelectorTagsToSite, api: "get_tags_to_site" },
        ]

        if (props.data[this.id] === undefined) props.data[this.id] = { ...props.data.genericData };
        if (props.data[this.week_id] === undefined) props.data[this.week_id] = { ...props.data.genericData };
        if (props.data[this.week_id_all] === undefined) props.data[this.week_id_all] = { ...props.data.genericData };
        if (props.data[this.setting_id] === undefined) props.data[this.setting_id] = {};

        this.selectors.forEach((x) => {
            if (props.data[x.id] === undefined) { props.data[x.id] = { ...props.data.genericSelector } }
        })
    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidMount() {
        this.selectors.forEach((x) => {
            if (this.props.isModalAutoIphone && x.api == 'list_pos') return
            if (x.api == 'get_tags_to_site') return
            this.props.dataActions.genericSelectorRefreshDataset(x.id, this.props.user.companyCode, this.props.user.token, x.api);
        })
        this.sendAPI(this.api.get_settings, { _branch: 0 }, ob => {
            let res = {}
            if (ob.data) {
                const [headers, data] = ob.data.split("\r").map(x => x.split("\f"))
                headers.forEach((x, i) => {
                    res = { ...res, [x]: data[i] }
                })
            }
            this.props.dataActions.setJson(this.setting_id, res)
        })

        this.props.dataActions.genericDataSetFilter(
            this.week_id_all,
            this.props.user.companyCode,
            this.props.user.token,
            { _branch: "", _tag: "" },
            this.api.get_week);
    }

    componentDidUpdate() {
        document.title = "Cash On Tab - " + this.getText(20000);
    }

    handleCancel = () => {
        if (this.props.data[this.id].editing == 0) this.props.dataActions.genericDataCancelInlineCreate(this.id)
        else this.props.dataActions.genericDataCancelEditing(this.id)
    }

    handleOk = () => {
        const { editedRecord } = this.props.data[this.id]
        if (!editedRecord.mItemCode && !this.state.importTagId) {
            message.error(this.getText(20021))
        } else if (!editedRecord.mEntityType || !editedRecord.mEntityCode) {
            message.error(this.getText(20022))
        } else if (editedRecord.mIsExcluded == '1' && !editedRecord.mFromDateTime && !editedRecord.mToDateTime && !editedRecord.mWeekDays && !editedRecord.mDailySaleQty) {
            message.error(this.getText(21944))
        } else {
            this.props.dataActions.genericDataSaveEditWithParams(
                this.id, this.props.user.companyCode, this.props.user.token, this.api.create_edit, this.api.get, { mTagId: this.state.importTagId });
        }
    }

    sendAPI = (script, data, sCal) => {
        let user = new User(this.props.user.token, this.props.user.companyCode);
        let job = new Job(user, script, OutputType.OUTPUT_TYPE_DATA, ProcessType.PROCESS_TYPE_SYNC);
        job.setInput(data);
        job.send("/cgi-bin/CashOnTab", sCal, (e) => { console.error(e) });
    }

    refreshData = () => {
        this.props.dataActions.genericDataGetRequested(
            this.id, this.props.user.companyCode, this.props.user.token, this.api.get);
    }

    onFilter = () => {
        const { _branchList, _itemTagList, _typeView } = this.state
        this.props.dataActions.genericDataSetFilter(
            this.id, this.props.user.companyCode, this.props.user.token, { _branchList, _itemTagList, _typeView, page: 1, _page_num: 1, _words: "" }, this.api.get);
    }

    handleClear = () => {
        this.setState({ _branchList: "", _itemTagList: "", _typeView: "0" }, this.onFilter)
    }

    handleFilter = () => {
        this.setState({ modalFilter: false }, this.onFilter)
    }

    getCheckBoxDays = (val, onChange) => {
        return (<Form.Item>
            {[1, 2, 3, 4, 5, 6, 7].map(x => {
                return (<Checkbox
                    checked={val.find(ff => ff == x) ? true : false}
                    onChange={e => {
                        onChange((e.target.checked ? [...val, x] : val.filter(f => f != x)))
                    }}>{this.getText(21213 + x)}</Checkbox>)
            })}
        </Form.Item>)
    }

    negativDays = (list) => {
        return '1234567'.split("").filter(f => !list || !list.find(ff => f == ff))
    }

    apiWeekTable = () => {
        const { modalWeekBranch, modalWeekCategory } = this.state

        this.props.dataActions.genericDataSetFilter(
            this.week_id,
            this.props.user.companyCode,
            this.props.user.token,
            { _branch: modalWeekBranch, _tag: modalWeekCategory },
            this.api.get_week);

    }

    render() {
        const gt = this.getText;
        const { editing, editedRecord, data, headers } = this.props.data[this.id]
        const sorter = true;
        const onChangeRecord = data => { this.props.dataActions.genericDataSetEdit(this.id, data) }
        const render = t => t;
        // const renderEntity = t => t == '1' ? gt(20011) : t == '2' ? gt(20012) : t == '3' ? gt(20013) : ""
        const renderSelector = (t, r) => (<GenericSelector {...this.props} id={this.selectors[r.mEntityType ? parseInt(r.mEntityType) - 1 : 0].id} value={t} disabled />)
        const renderCheckbox = t => (<Checkbox checked={t == '1'} readOnly />)
        const renderDatetime = t => t ? moment(t).format("DD/MM/YYYY HH:mm:ss") : ""
        const renderEdit = (t, r) => (<TableLineIcons
            onEdit={() => {
                this.props.dataActions.genericDataStartEditing(this.id, r.key, r.index)
                this.setState({ editWeekDaysNotExc: r.mDailySaleQty ? "-2" : r.mFromDateTime || r.mToDateTime ? "-1" : "1" })
            }}
            // onDelete={() => { this.props.dataActions.genericDataDeleteRow(this.id, r.key, this.props.user.companyCode, this.props.user.token, this.api.delete, this.api.get) }}
            // deleteQuetion={{ title: gt(20014), okText: gt(20015), cancelText: gt(20016) }}
            genericIcons={[
                {
                    type: r.mIsExcluded == 1 ? "minus-square" : "check-square",
                    onClick: () => {
                        let findRow = [...data.map(x => x.split("\f")).find(f => f[0] == r.key)]
                        findRow[5] = r.mIsExcluded == 1 ? "0" : "1";
                        findRow[6] = r.mIsExcluded == 1 ? "" : moment().format("YYYY-MM-DD HH:mm:ss");
                        findRow[7] = "";
                        this.sendAPI(this.api.create_edit, headers.join("\f") + "\fmTagId\r" + findRow.join("\f") + "\f", this.refreshData)
                    },
                    tooltip: gt(r.mIsExcluded == 1 ? 20097 : 20096),
                    popconfirm: { title: gt(r.mIsExcluded == 1 ? 20099 : 20098), okText: gt(20015), cancelText: gt(20016) },
                }
            ]}
        />)

        const renderWeekDays = days => ' אבגדהוז'.split("").map((x, i) => days.split(",").find(f => f == i) ? x : null).filter(ff => ff).join(", ")


        const divStyle = {
            align: "center",
            dir: "rtl", // dir: "ltr"
            padding: "2% 2% 2% 2%",
        };

        const colSpan = window.innerWidth > 600 ? 12 : 24

        const defaultExcludeDates = { mFromDateTime: moment().format("YYYY-MM-DD HH:mm:ss"), mDailySaleQty: null }

        const { _branchList, _itemTagList, _typeView } = this.state
        const { pViewOnlyExcludeItems } = this.props.data[this.setting_id];



        return (<div style={divStyle}>
            <GenericTable
                {...this.props}
                id={this.id}
                getApi={this.api.get}
                title={gt(20001)}
                columns={[
                    { title: gt(20003), key: "mItemCode", dataIndex: "mItemCode", width: "10%", sorter, render },
                    { title: gt(20004), key: "mItemName", dataIndex: "mItemName", width: "18%", sorter, render },
                    { title: gt(20006), key: "mEntityCode", dataIndex: "mEntityCode", width: "16%", sorter, render: renderSelector },
                    { title: gt(pViewOnlyExcludeItems == 1 ? 21970 : 20007), key: "mIsExcluded", dataIndex: "mIsExcluded", width: "6%", sorter, render: renderCheckbox },
                    { title: gt(pViewOnlyExcludeItems == 1 ? 21971 : 20008), key: "mFromDateTime", dataIndex: "mFromDateTime", width: "12%", sorter, render: renderDatetime },
                    { title: gt(pViewOnlyExcludeItems == 1 ? 21972 : 20009), key: "mToDateTime", dataIndex: "mToDateTime", width: "12%", sorter, render: renderDatetime },
                    { title: gt(pViewOnlyExcludeItems == 1 ? 21973 : 21211), key: "mWeekDays", dataIndex: "mWeekDays", width: "10%", sorter, render: renderWeekDays },
                    { title: gt(22026), key: "mDailySaleQty", dataIndex: "mDailySaleQty", width: "10%", sorter, render },
                    { title: gt(20010), width: "6%", render: renderEdit },
                ]}
                searchBox
                addButton={() => {
                    this.props.dataActions.genericDataStartInlineCreate(this.id)
                    setTimeout(() => {
                        let branchesDataset = this.props.data[this.selectors[0].id].dataset;
                        let initData = { mEntityType: '1', mIsExcluded: '1', editWeekDaysNotExc: '-1', ...defaultExcludeDates }
                        if (branchesDataset?.length == 1) initData = { ...initData, mEntityCode: branchesDataset[0].code }
                        onChangeRecord(initData)
                    }, 500);
                }}
                actionButtons={[{
                    buttonType: 'filter',
                    buttonFunction: () => { this.setState({ modalFilter: true }) }
                }]}
                genericActionButtons={[
                    <Tooltip title={gt(21221)}>
                        <Button style={{ marginLeft: 5 }} onClick={() => {
                            this.setState({
                                modalWeekView: true,
                                modalWeekBranch: this.props.data[TableIDs.genericSelectorBranches].dataset[0]?.code
                            }, this.apiWeekTable)
                        }}>
                            <Icon type="calendar" style={{ fontSize: 16 }} />
                        </Button>
                    </Tooltip>
                ]}
                filters={{ _branchList, _itemTagList, _typeView }}
                percentageToMobile={[20, 40, null, 20, null, null, 20]}
                isModal={this.props.isModalAutoIphone}
                modalCancel={this.props.onCancel}
            />
            <GenericModal
                visible={editing > -1}
                onCancel={() => { this.props.dataActions[editing == 0 ? "genericDataCancelInlineCreate" : "genericDataCancelEditing"](this.id) }}
                title={gt(20017)}
                width={1000}
                footer={[
                    <Button onClick={this.handleCancel}>{gt(20019)}</Button>,
                    <Button type="primary" onClick={this.handleOk}>{gt(20020)}</Button>,
                ]}>
                <Row>
                    <Col span={colSpan}>
                        <Form.Item label={gt(20003)} required validateStatus={!editedRecord.mItemCode && !this.state.importTagId ? "error" : "success"}>
                            <SelectorItemClassic
                                {...this.props}
                                valueId={editedRecord.mItemCode}
                                valueName={editedRecord.mItemName}
                                onChange={(mItemCode, mItemName) => { this.setState({ importTagId: null }, () => { onChangeRecord({ mItemCode, mItemName }) }) }}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={colSpan}>
                        {editing == 0 ?
                            <Form.Item label={gt(20018)}>
                                <GenericSelectorItemTags
                                    {...this.props} notReport
                                    value={this.state.importTagId}
                                    onChange={e => { this.setState({ importTagId: e }, () => { onChangeRecord({ mItemCode: null, mItemName: null }) }) }}
                                />
                            </Form.Item>
                            : ""}
                    </Col>
                </Row>

                {/* <Row>
                    <Col span={colSpan}>
                        <Form.Item label={gt(20005)} required validateStatus={!editedRecord.mEntityType ? "error" : "success"}>
                            <Select style={{ width: 250 }} value={editedRecord.mEntityType} onChange={e => { onChangeRecord({ mEntityType: e, mEntityCode: null }) }}>
                                <Select.Option value="1">{gt(20011)}</Select.Option>
                                <Select.Option value="2">{gt(20012)}</Select.Option>
                                <Select.Option value="3">{gt(20013)}</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={colSpan}> */}
                <Form.Item label={gt(20006)} required validateStatus={!editedRecord.mEntityCode ? "error" : "success"}>
                    <GenericSelector {...this.props}
                        id={this.selectors[editedRecord.mEntityType ? parseInt(editedRecord.mEntityType) - 1 : 0].id}
                        value={editedRecord.mEntityCode} onChange={e => { onChangeRecord({ mEntityCode: e }) }}
                    />
                </Form.Item>
                {/* </Col>
                </Row> */}

                <Form.Item>
                    <Checkbox
                        checked={editedRecord.mIsExcluded == '1'}
                        onChange={e => { onChangeRecord(e.target.checked ? { mIsExcluded: "1", ...defaultExcludeDates } : { mIsExcluded: "0", mFromDateTime: null, mToDateTime: null }) }}
                    >{gt(20007)}</Checkbox>
                </Form.Item>

                <Form.Item>
                    <Radio.Group value={this.state.editWeekDaysNotExc} onChange={e => {
                        this.setState({ editWeekDaysNotExc: e.target.value })
                        if (e.target.value == '-1') onChangeRecord(defaultExcludeDates)
                        else if (e.target.value == '-2') onChangeRecord({ mFromDateTime: null, mToDateTime: null, mWeekDays: "" })
                        else onChangeRecord({ mFromDateTime: null, mToDateTime: null, mDailySaleQty: null })
                    }}>
                        <Radio value={"-1"}>{gt(21943)}</Radio><br />
                        <Radio value={"1"}>{gt(21212)}</Radio><br />
                        <Radio value={"0"}>{gt(21213)}</Radio><br />
                        <Radio value={"-2"}>{gt(22027)}</Radio><br />
                    </Radio.Group>
                </Form.Item>

                {this.state.editWeekDaysNotExc == '1' ?
                    this.getCheckBoxDays(this.negativDays(editedRecord.mWeekDays?.split(",")), e => { onChangeRecord({ mWeekDays: this.negativDays(e).join(",") }) })
                    : this.state.editWeekDaysNotExc == '0' ?
                        this.getCheckBoxDays(editedRecord.mWeekDays ? editedRecord.mWeekDays.split(",") : [], e => { onChangeRecord({ mWeekDays: e ? e.join(",") : "" }) })
                        : this.state.editWeekDaysNotExc == '-2' ?
                            <Form.Item label={gt(22028)}>
                                <InputNumber
                                    value={editedRecord.mDailySaleQty}
                                    onChange={e => { onChangeRecord({ mDailySaleQty: e }) }}
                                />
                            </Form.Item>
                            : <Row>
                                <Col span={colSpan}>
                                    <Form.Item label={gt(20008)}>
                                        <DateTimePicker
                                            format="DD/MM/YYYY HH:mm"
                                            value={editedRecord.mFromDateTime}
                                            onChange={e => { onChangeRecord({ mFromDateTime: e }) }}
                                            maxDate={editedRecord.mToDateTime}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={colSpan}>
                                    <Form.Item label={gt(20009)}>
                                        <DateTimePicker
                                            format="DD/MM/YYYY HH:mm"
                                            value={editedRecord.mToDateTime}
                                            onChange={e => { onChangeRecord({ mToDateTime: e }) }}
                                            minDate={editedRecord.mFromDateTime}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                }


            </GenericModal>

            <GenericModal
                visible={this.state.modalFilter}
                onCancel={() => { this.setState({ modalFilter: false }) }}
                title={gt(20100)}
                width={600}
                footer={[
                    <Button onClick={() => { this.setState({ modalFilter: false }) }}>{gt(20101)}</Button>,
                    <Button onClick={this.handleClear}>{gt(20102)}</Button>,
                    <Button type="primary" onClick={this.handleFilter}>{gt(20103)}</Button>,
                ]}>
                <Form.Item label={gt(20105)}>
                    <GenericSelector {...this.props} multi
                        id={this.selectors[0].id}
                        value={_branchList ? _branchList.split(",") : []}
                        onChange={e => { this.setState({ _branchList: e ? e.join(",") : "" }) }}
                    />
                </Form.Item>
                <Form.Item label={gt(22037)}>
                    <GenericSelectorItemTags {...this.props} multi
                        value={_itemTagList ? _itemTagList.split(",") : []}
                        onChange={e => { this.setState({ _itemTagList: e ? e.join(",") : "" }) }}
                    />
                </Form.Item>
                <Form.Item label={gt(20104)}>
                    <Radio.Group
                        value={_typeView}
                        onChange={e => { this.setState({ _typeView: e.target.value }) }}
                    >
                        <Radio value={'0'}>{gt(20106)}</Radio><br />
                        <Radio value={'1'}>{gt(20107)}</Radio><br />
                        <Radio value={'2'}>{gt(20108)}</Radio><br />
                    </Radio.Group>
                </Form.Item>
            </GenericModal>

            <GenericModal
                visible={this.state.modalWeekView}
                onCancel={() => {
                    this.setState({ modalWeekView: false, modalWeekBranch: null, modalWeekCategory: null }, () => {
                        this.props.dataActions.setJson(this.week_id, { data: [], count: 0 })
                    })
                }}
                title={gt(21222)}
                width={1000}
                genericActionButtons={[
                    <Tooltip title={gt(22128)}>
                        <Button style={{ margin: 5 }} onClick={() => {
                            this.setState({ modalWeekViewExcelPrint: "noCode" })
                        }}>
                            <Icon style={{ fontSize: 20 }} className={"clickable margin-4"} type={"file-excel"} />
                        </Button>
                    </Tooltip>
                ]}
            >
                <Row>
                    <Col span={window.innerWidth > 600 ? 12 : 24}>
                        {gt(21223)}:
                        <GenericSelectorBranches
                            {...this.props}
                            value={this.state.modalWeekBranch}
                            onChange={e => { this.setState({ modalWeekBranch: e }, this.apiWeekTable) }}
                        />
                    </Col>
                    <Col span={window.innerWidth > 600 ? 12 : 24}>
                        {gt(21224)}:
                        <GenericSelector {...this.props} {...this.selectors[3]}
                            value={this.state.modalWeekCategory}
                            onChange={e => { this.setState({ modalWeekCategory: e }, this.apiWeekTable) }}
                            filters={{ tParnetId: -1, tDatetime: null }}
                            addFirstRow={{ code: '0', name: "-" }}
                        />
                    </Col>
                </Row>
                <ResponsiveTable
                    tableOnly
                    idTable={this.props.data[this.week_id]}
                    columns={[
                        { title: gt(21214), key: "d1", dataIndex: "d1", width: "14%", render },
                        { title: gt(21215), key: "d2", dataIndex: "d2", width: "14%", render },
                        { title: gt(21216), key: "d3", dataIndex: "d3", width: "14%", render },
                        { title: gt(21217), key: "d4", dataIndex: "d4", width: "14%", render },
                        { title: gt(21218), key: "d5", dataIndex: "d5", width: "14%", render },
                        { title: gt(21219), key: "d6", dataIndex: "d6", width: "14%", render },
                        { title: gt(21220), key: "d7", dataIndex: "d7", width: "14%", render },
                    ]}
                    pagination={false}
                    scroll={{ y: window.innerHeight - 300 }}
                />
            </GenericModal>
            <GenericModal
                visible={this.state.modalWeekViewExcelPrint != null}
                onCancel={() => { this.setState({ modalWeekViewExcelPrint: null }) }}
                width={300}
                footer={[
                    <Button onClick={() => { this.setState({ modalWeekViewExcelPrint: null }) }}>{gt(22132)}</Button>,
                    <ReportExcelBtn
                        {...this.props}
                        btnStyle
                        btnType="primary"
                        btnText={gt(22131)}
                        reportName={"WeeklyMenu-" + moment().format("DDMMYYYY")}
                        excelDataset={[{
                            name: "WeeklyMenu-" + moment().format("DDMMYYYY"),
                            data: this.state.modalWeekViewExcelPrint == "noCode" ?
                                [
                                    [gt(22133), gt(22134), gt(21214), gt(21215), gt(21216), gt(21217), gt(21218), gt(21219), gt(21220)],
                                    ...this.props.data[this.week_id_all].data.map(x => {
                                        let y = x.split("\f")
                                        return [y[8], y[9], y[1], y[2], y[3], y[4], y[5], y[6], y[7]]
                                    })
                                ]
                                : [
                                    [
                                        gt(22133), gt(22134),
                                        `${gt(21214)}-${gt(22135)}`, `${gt(21214)}-${gt(22136)}`,
                                        `${gt(21215)}-${gt(22135)}`, `${gt(21215)}-${gt(22136)}`,
                                        `${gt(21216)}-${gt(22135)}`, `${gt(21216)}-${gt(22136)}`,
                                        `${gt(21217)}-${gt(22135)}`, `${gt(21217)}-${gt(22136)}`,
                                        `${gt(21218)}-${gt(22135)}`, `${gt(21218)}-${gt(22136)}`,
                                        `${gt(21219)}-${gt(22135)}`, `${gt(21219)}-${gt(22136)}`,
                                        `${gt(21220)}-${gt(22135)}`, `${gt(21220)}-${gt(22136)}`,
                                    ],
                                    ...this.props.data[this.week_id_all].data.map(x => {
                                        let y = x.split("\f")
                                        return [
                                            y[8], y[9],
                                            y[1] ? y[0] : "", y[1],
                                            y[2] ? y[0] : "", y[2],
                                            y[3] ? y[0] : "", y[3],
                                            y[4] ? y[0] : "", y[4],
                                            y[5] ? y[0] : "", y[5],
                                            y[6] ? y[0] : "", y[6],
                                            y[7] ? y[0] : "", y[7],
                                        ]
                                    })
                                ]
                        }]}
                        onEndPrint={() => { this.setState({ modalWeekViewExcelPrint: null }) }}
                    />,
                ]}>
                <Radio.Group value={this.state.modalWeekViewExcelPrint} onChange={e => { this.setState({ modalWeekViewExcelPrint: e.target.value }) }}>
                    <Radio value={"noCode"}>{gt(22129)}</Radio><br />
                    <Radio value={"withCode"}>{gt(22130)}</Radio>
                </Radio.Group>
            </GenericModal>
        </div>)
    }

}

export default ExcludedItems;